import React, { Component } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { trackReferralsCopiedReferralLink } from '../../../elements/tracking/referralsTracking.js'
import './copyLink.css'
class CopyRefCode extends Component {
  constructor(props) {
    super(props)
    this.state = {
      refCopied: false,
    }
  }

  onCopyLink = () => {
    this.setState({ refCopied: true })
    trackReferralsCopiedReferralLink()
    setTimeout(() => this.setState({ refCopied: false }), 2500)
  }

  render() {
    const { refCode } = this.props

    const alignClass = this.props.centered
      ? 'has-text-centered'
      : 'has-text-left'

    return (
      <div className="ref-copy-input-wrap">
        <input
          id="ref-link"
          disabled
          className="ref-link-input"
          defaultValue={'https://www.twistedroad.com/ref/' + refCode}
        />
        <CopyToClipboard
          text={'https://www.twistedroad.com/ref/' + refCode}
          onCopy={() => this.onCopyLink()}
        >
          <button className="ref-copy-link-button">COPY</button>
        </CopyToClipboard>
        {this.state.refCopied && (
          <div
            className={
              'has-text-success is-size-7 link-copied-ref ' + alignClass
            }
          >
            Link Copied!
          </div>
        )}
      </div>
    )
  }
}

export default CopyRefCode

CopyRefCode.defaultProps = {
  refCode: 'CODEMISSING',
  centered: true,
}
